import React from "react";
import { Box, Paper } from "@mui/material";

export interface PremiumPageProps {
  children: React.ReactNode;
  /** Skip the inner Paper wrapper if a page already manages its own card. */
  disablePaper?: boolean;
}

/**
 * Premium page wrapper used to overlay DCC styling on top of legacy pages
 * without rewriting their internals.
 *
 * Drop-in usage:
 *   <PremiumPage>
 *     ...existing page content...
 *   </PremiumPage>
 */
export default function PremiumPage({ children, disablePaper }: PremiumPageProps) {
  return (
    <Box
      sx={{
        padding: "24px",
        background: "#F8FAFC",
        minHeight: "100vh",
      }}
    >
      {disablePaper ? (
        children
      ) : (
        <Paper
          elevation={0}
          sx={{
            borderRadius: "14px",
            padding: "20px",
            background: "#FFFFFF",
            boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
          }}
        >
          {children}
        </Paper>
      )}
    </Box>
  );
}
